module.exports = __webpack_public_path__ + "static/media/rest.ed87f307.png";